/**
 * Product description "Leggi di più" / "Leggi di meno" toggle (~10 righe).
 * Cerca .product-description-toggle nella pagina e inizializza overflow + click.
 */
(function() {
  function initProductDescriptionToggle() {
    document.querySelectorAll('.product-description-toggle').forEach(function(wrap) {
      if (wrap.dataset.jsInited === '1') return;
      var content = wrap.querySelector('.product-description-toggle__content');
      var btn = wrap.querySelector('.product-description-toggle__btn');
      if (!content || !btn) return;
      wrap.dataset.jsInited = '1';
      var details = wrap.closest('details.cc-accordion-item');
      function checkOverflow() {
        if (details && !details.open) return;
        content.style.webkitLineClamp = '';
        content.style.display = '';
        content.style.overflow = '';
        var fullHeight = content.scrollHeight;
        content.style.webkitLineClamp = '10';
        content.style.display = '-webkit-box';
        content.style.overflow = 'hidden';
        var hasOverflow = fullHeight > content.clientHeight + 2;
        if (hasOverflow) {
          btn.removeAttribute('hidden');
        } else {
          btn.setAttribute('hidden', '');
          content.style.webkitLineClamp = '';
          content.style.overflow = '';
        }
      }
      if (details && !details.open) {
        details.addEventListener('toggle', function onOpen() {
          if (details.open) {
            details.removeEventListener('toggle', onOpen);
            setTimeout(checkOverflow, 50);
          }
        });
      } else {
        setTimeout(checkOverflow, 100);
      }
      window.addEventListener('resize', checkOverflow);
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var expanded = wrap.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', expanded);
        btn.textContent = expanded ? (btn.getAttribute('data-less') || 'Leggi di meno') : (btn.getAttribute('data-more') || 'Leggi di più');
        if (expanded) {
          content.style.webkitLineClamp = '';
          content.style.display = '';
          content.style.overflow = '';
        } else {
          content.style.webkitLineClamp = '10';
          content.style.display = '-webkit-box';
          content.style.overflow = 'hidden';
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductDescriptionToggle);
  } else {
    initProductDescriptionToggle();
  }
  document.addEventListener('shopify:section:load', initProductDescriptionToggle);
})();
